module.exports = __webpack_public_path__ + "static/media/pw-points-icon.895069e5.svg";